var _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncreaseRevenueNordyne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.6133 65.7585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Increase Revenue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "twoToneSecondary",
    points: "54.0034 13.4889 53.3188 3.8727 42.6909 5.4469 42.2515 2.4792 56.0806 .4303 56.9956 13.276 54.0034 13.4889"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "twoToneSecondary",
    points: "53.8979 65.7585 0 65.7585 0 11.965 3 11.965 3 62.7585 53.8979 62.7585 53.8979 65.7585"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "twoToneSecondary",
    x: 9.9922,
    y: 40.2956,
    width: 3,
    height: 16.6543
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "twoToneSecondary",
    x: 21.8721,
    y: 28.3044,
    width: 3,
    height: 28.6445
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "twoToneSecondary",
    x: 33.7515,
    y: 34.6325,
    width: 3,
    height: 22.3164
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "twoToneSecondary",
    x: 45.6313,
    y: 24.3073,
    width: 3,
    height: 32.6426
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "twoToneSecondary",
    points: "10.7637 31.318 8.5566 29.2868 22.9971 13.5978 34.9434 23.2223 52.9839 2.0182 55.269 3.9626 35.3359 27.3913 23.3018 17.6965 10.7637 31.318"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseRevenueNordyne);
export default __webpack_public_path__ + "static/media/increase-revenue-Nordyne.0d3541460d5e28bb8e3a44bae06e31ac.svg";
export { ForwardRef as ReactComponent };